<template>
  <div class="expand-container">
    <table class="sub-table" v-if="record.sub_programs && record.sub_programs.length">
      <thead>
        <tr>
          <th style="width:50px; text-align:center;">{{ $t('numberic') }}</th>
          <th>{{ $t('paymentannouncement.mainProgram') }}</th>
          <th>{{ $t('paymentannouncement.subProgram') }}</th>
          <th>{{ $t('paymentannouncement.grade') }}</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(program, pIndex) in record.sub_programs">
          <template v-if="record.grades && record.grades.length">
            <tr v-for="(grade, gIndex) in record.grades" :key="pIndex + '-' + gIndex">
              <td class="text-center">{{ gIndex + 1 }}</td>
              <td>{{ program.acp_name_foreign }}</td>
              <td>{{ program.acps_name_foreign }}</td>
              <td>{{ grade.grade_name_foreign }}</td>
            </tr>
          </template>

          <tr v-else :key="'no-grade-' + pIndex">
            <td class="text-center">{{ pIndex + 1 }}</td>
            <td>{{ program.acp_name_foreign }}</td>
            <td>{{ program.acps_name_foreign }}</td>
            <td>{{ $t('All Grade') }}</td>
          </tr>
        </template>
      </tbody>
    </table>

    <div v-else class="text-center text-muted mt-3">
      {{ $t('noData') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'table-expand',
  props: {
    record: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.expand-container {
  padding: 4px 8px;
}

.sub-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.sub-table th {
  background-color: #f0f0f0;
  border-bottom: 1px solid #ddd;
  padding: 6px 10px;
  font-weight: 600;
  color: #555;
}

.sub-table td {
  border-bottom: 1px solid #eee;
  padding: 6px 10px;
  color: #333;
}

.sub-table tbody tr:last-child td {
  border-bottom: none;
}

.sub-table tbody tr:hover {
  background-color: #fafafa;
}

.text-center {
  text-align: center;
}

.mt-3 {
  margin-top: 1rem;
}
</style>
